import {
    ADD_TO_CART,
    ADD_TO_CART_RESET
} from '../actions/cart';

const initialState = {
    addToCartSuccess: null,
    addToCartError: null,
    addToCartErrorMessage: null
};

export default function cartReducer(state = initialState, action) {
    switch (action.type) {
        case ADD_TO_CART:
            return {
                ...state,
                ...(action.payload && action.payload.addToCartSuccess && {
                    addToCartSuccess: true
                }),
                ...(action.payload && action.payload.message && action.error && {
                    addToCartErrorMessage: action.payload.message
                }),
                addToCartError: action.error
            };
        case ADD_TO_CART_RESET:
            return {
                ...state,
                addToCartSuccess: initialState.addToCartSuccess,
                addToCartError: initialState.addToCartError,
                addToCartErrorMessage: initialState.addToCartErrorMessage
            };
        default:
            return state;
    }
}